import { Text, Button } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * RecommendLink インターフェース
 * 推奨リンクのプロパティ
 */
export interface RecommendLink {
  /** リンクのテキスト */
  text: string;
  /** リンクURL */
  href: string;
}

/**
 * RecommendLinksコンポーネントのProps
 */
interface RecommendLinksProps {
  /** リンクデータの配列 */
  data: RecommendLink[];
}

/**
 * そのほかの検索条件リンクコンポーネント
 * @param {RecommendLinksProps} props - コンポーネントのプロパティ
 * @returns {JSX.Element} RecommendLinksのJSX要素
 */
export const RecommendLinks = ({ data }: RecommendLinksProps) => {
  return (
    <div>
      <Text
        as="p"
        color="black_pc"
        size="12"
        weight="normal"
        className={styles.recommendLinks__title}
      >
        そのほかの検索条件
      </Text>
      <div className={styles.recommendLinks__list}>
        {data.map((link) => (
          <Button
            as="a"
            href={link.href}
            variant="outline_blue"
            size="XS"
            className={styles.recommendLinks__link}
            key={link.text}
          >
            {link.text}
          </Button>
        ))}
      </div>
    </div>
  );
};
